import React, { useContext } from 'react';
import { LinkLocation } from './GenericCarousel.type';

export type GenericCarouselContextType = {
    carouselName: string;
    carouselId: string;
    carouselUrl?: string;
    linkLocation?: LinkLocation;
};

const defaultGenericCarouselContext = {
    carouselName: '',
    carouselId: '',
    carouselUrl: '',
    linkLocation: undefined,
};

const GenericCarouselContext = React.createContext<GenericCarouselContextType>(
    defaultGenericCarouselContext,
);

export const useGenericCarouselContext = (): GenericCarouselContextType =>
    useContext(GenericCarouselContext);

export default GenericCarouselContext;
